(function () {
    "use strict";
    angular.module("skillBuilderSaaS")
        .controller("TranscriptCtrl", ["$http", "$timeout", "$translate", transcriptCtrl]);
    function transcriptCtrl($http, $timeout, $translate) {
        var vm = this;
        vm.isLoading = true;
        vm.isCanceled = false;
        var translations = {
            labelTranscript: $translate.instant("account.transcript.transcriptLabel"),
            labelPathName: $translate.instant("account.transcript.learningPath"),
            labelStatus: $translate.instant("account.transcript.status"),
            labelAssignedDate: $translate.instant("account.transcript.assigned"),
            labelActivatedDate: $translate.instant("account.transcript.activated"),
            labelCompletedDate: $translate.instant("account.transcript.completed"),
            labelExpirydDate: $translate.instant("account.transcript.expiry"),
            labelItemName: $translate.instant("account.transcript.itemName"),
            labelItemType: $translate.instant("account.transcript.itemType"),
            labelScore: $translate.instant("account.transcript.score")
        };
        $http.post("api/account/transcript", translations, { responseType: "arraybuffer" })
            .then(function (result) {
            if (vm.isCanceled)
                return;
            $timeout(function () {
                var blob = new Blob([result.data], { type: "application/pdf" });
                //Chrome for iOS has problems with blobs...
                //Issue logged on: https://github.com/eligrey/FileSaver.js/issues/179
                window.saveAs(blob, "transcript.pdf");
                vm.isLoading = false;
            });
        }).catch(angular.noop);
    }
}());
